import { useContext } from 'react';
import { FeaturesContext } from '../context';

const useFeatures = () => {
  const features = useContext(FeaturesContext);
  return { ...features?.features };
};

export default useFeatures;
